import React from 'react'
import { $DCprimaryColor, DcInput, PixelCurrency } from 'pixel-base'
import styled from 'styled-components'
import { OrderDetail, LineItem } from '../../../../../../../decl.d'
interface IProps {
  isEditable: boolean
  newProductQuantity: {
    line_item_id: number
    quantity: string
    price: string
  }
  newOrder: boolean
  setNewOrderData: (data: OrderDetail) => void
  newOrderData: OrderDetail
  item: LineItem
  setNewProductQuantity: (data: {
    line_item_id: number
    quantity: string
    price: string
  }) => void
}

const PriceContainer = (props: IProps) => {
  const {
    isEditable,
    newProductQuantity,
    newOrder,
    setNewOrderData,
    newOrderData,
    item,
    setNewProductQuantity,
  } = props
  return (
    <Price>
      <InlineSection>
        {isEditable ? (
          <>
            <DcInput
              noPadding
              required
              type="number"
              name={'date'}
              min={'0'}
              isShowLabel={false}
              placeholder={'Price'}
              value={newProductQuantity.price}
              onChange={(e) => {
                if (newOrder) {
                  setNewOrderData({
                    ...newOrderData,
                    line_items: newOrderData.line_items.map((key) => {
                      if (key.product_id === item.product_id) {
                        return {
                          ...key,
                          price: Number(e.target.value),
                        }
                      }
                      return key
                    }),
                  })
                } else {
                  setNewProductQuantity({
                    ...newProductQuantity,
                    price: e.target.value,
                  })
                }
              }}
            />
          </>
        ) : (
          <PixelCurrency value={item.price} />
        )}
      </InlineSection>
    </Price>
  )
}
const Price = styled.div<{ justify?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`
const InlineSection = styled.div<{ color?: string }>`
  font-size: 12px;
  font-weight: 400;
  color: ${(props) =>
    props.color === 'primary' ? $DCprimaryColor : 'rgba(0, 0, 0, 0.87)'};
`
export default PriceContainer
